// @flow

import * as React from 'react';
import { localize } from '@ta/common.i18n';
import classNames from '@ta/common.classnames';
import SideBarNavItem from './SideBarNavItem';
import { type NavLinkType } from '../types';
import styles from './SideBarSettingsLinks.less';

/** The component that will render the Settings links */
const SideBarSettingsLinks = () => {
  /** The NavLinkType that represents the settings link in the sidebar menu */
  const settingsLink: NavLinkType = {
    id: 'settings',
    text: localize('mem_settings'),
    url: '/MobileNativeSettings',
    forceCollapse: false,
    trackingLabel: 'UserProfile_settings',
    isNewWindow: false,
    urlWithGeoTemplate: null,
    urlWithLatLngTemplate: null,
    icon: null,
    isNoFollow: true,
    hideFromSidebar: false,
    sidebarPostCollapsed: true,
    promoteAsNew: false,
    subList: [],
  };

  /** The NavLinkType that represents the sign out link in the sidebar menu */
  const signOutLink: NavLinkType = {
    id: 'signout',
    text: localize('common_Signout'),
    url: '/RegistrationController?flow=sign_out&pid=1&returnTo=%2F&fullscreen=true',
    forceCollapse: false,
    trackingLabel: 'UserProfile_signout',
    isNewWindow: false,
    urlWithGeoTemplate: null,
    urlWithLatLngTemplate: null,
    icon: null,
    isNoFollow: true,
    hideFromSidebar: false,
    sidebarPostCollapsed: true,
    promoteAsNew: false,
    subList: [],
  };

  const containerClasses = classNames('ui_container', styles.container);
  return (
    <ul className={containerClasses}>
      <SideBarNavItem key={settingsLink.id} link={settingsLink} hasWhiteText />
      <SideBarNavItem key={signOutLink.id} link={signOutLink} hasWhiteText />
    </ul>
  );
};

export default SideBarSettingsLinks;
